"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var reselect_1 = require("reselect");
/**
 * Provides an ErrorList React Context for tracking a list of errors.
 * The list should be scoped to some reasonable context, such as a place page.
 * Children that emit errors can use ErrorReporter to do so, or add errors directly via addError.
 * Those errors can be handled by children that subscribe, such as ErrorToasts.
 */
var ErrorListProvider = /** @class */ (function (_super) {
    __extends(ErrorListProvider, _super);
    function ErrorListProvider(props) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line:typedef
        _this.memoizedCreateErrorList = reselect_1.defaultMemoize(createErrorList);
        _this.nextErrorId = 1;
        _this.addError = function (errorDisplayInfo) {
            var errorId = "error_" + _this.nextErrorId++;
            var newError = __assign(__assign({}, errorDisplayInfo), { errorId: errorId });
            _this.setState(function (prevState) { return ({
                errors: prevState.errors.concat(newError)
            }); });
            return errorId;
        };
        _this.removeError = function (errorId) {
            _this.setState(function (prevState) { return ({
                errors: prevState.errors.filter(function (e) { return e.errorId !== errorId; })
            }); });
        };
        _this.clearErrors = function () {
            _this.setState({ errors: [] });
        };
        _this.state = { errors: [] };
        return _this;
    }
    ErrorListProvider.prototype.render = function () {
        var errorList = this.memoizedCreateErrorList(this.state.errors, this);
        return (React.createElement(data_catalog_shared_1.ErrorListContext.Provider, { value: errorList }, this.props.children));
    };
    return ErrorListProvider;
}(React.Component));
exports.ErrorListProvider = ErrorListProvider;
function createErrorList(errors, provider) {
    return {
        errors: errors,
        addError: provider.addError,
        removeError: provider.removeError,
        clearErrors: provider.clearErrors,
    };
}
//# sourceMappingURL=ErrorListProvider.js.map